export default "__VITE_ASSET__C_j0SvLI__"